import uuid from "uuid/v4";

type SuccessAktivoOnBooardResponse = {
  retrieveAktivoToken: {
    access_token: string;
    aktivo_id: string;
    refresh_token: string;
    expires_in: number;
  };
};

type FailureAktivoOnBooardResponse =
  | {
      message: string;
    }
  | {
      response: {
        reasonCode: string;
        reason: string;
      };
    };

export type AktivoOnBooardResponse =
  | SuccessAktivoOnBooardResponse
  | FailureAktivoOnBooardResponse;

export type AktivoOnBooardRequestObject = {
  token: string;
  msgid?: string;
};

export const aktivoOnBoard: (
  apiEndpoint: string,
  obj: AktivoOnBooardRequestObject,
  onError?: (n: string) => void
) => Promise<AktivoOnBooardResponse> = (apiEndpoint, { token }, onError) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + token);
  myHeaders.append("x-axahk-msgid", uuid());
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({}),
    redirect: "follow",
  };

  return fetch(
    apiEndpoint + "/api/emma/aktivoOnboarding?featureName=userOnboard",
    requestOptions
  ).then((response) => {
    return response.json();
  });
};
